
import axiosInstance from "../axiosInstance";
import moment from "moment";
import Auth from '../modules/auth';

export const getManevre = async () => {
  try {
    var token = await Auth.getTokenVolunteer();
    const manevre = await axiosInstance.get(`/volunteer/manevre`,{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    return manevre.data;
  } catch (error) {
    console.error(error);
  }
};

export const getPatients = async () => {
  try {
    var token = await Auth.getTokenVolunteer();
    const patients = await axiosInstance.get(`/volunteer/patients`,{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    return patients.data;
  } catch (error) {
    console.error(error);
  }
};

export const getPatientsAdmin = async () => {
  try {
    var token = await Auth.getToken();
    const patients = await axiosInstance.get(`/volunteer/patients`,{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    return patients.data;
  } catch (error) {
    console.error(error);
  }
};

export const addPatient = async (patient) => {
  try {
    var token = await Auth.getToken();
    const addPatient = await axiosInstance.post(`/volunteer/patients`, patient,{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    return addPatient.data;
  } catch (error) {
    console.error(error);
  }
};

export const sendRequest = async (data) => {
  try {
    var token = await Auth.getTokenVolunteer();
    const sendRequest = await axiosInstance.post(`/volunteer/request`, data,{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    return sendRequest.data;
  } catch (error) {
    console.error(error);
  }
};

export const sendMessage = async (data) => {
  try {
    var token = await Auth.getToken();
    const sendRequest = await axiosInstance.post(`/volunteer/requestMessage`, data,{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    return sendRequest.data;
  } catch (error) {
    console.error(error);
  }
};


export const getRequests = async () => {
  try {
    var token = await Auth.getToken();
    const requests = await axiosInstance.get(`/volunteer/request`,{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    return requests.data;
  } catch (error) {
    console.error(error);
  }
};

export const archiveRequest = async (requestId) => {
  try {
    var token = await Auth.getToken();
    const archiveRequest = await axiosInstance.delete(`/volunteer/request/${requestId}`,{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    return archiveRequest.data;
  } catch (error) {
    console.error(error);
  }
};


export const deletePatient = async (patientId) => {
  try {
    var token = await Auth.getToken();
    const deletePatient = await axiosInstance.delete(`/volunteer/patients/${patientId}`,{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    return deletePatient.data;
  } catch (error) {
    console.error(error);
  }
};

export const getVolunteers = async () => {
  try {
    var token = await Auth.getToken();
    const volunteers = await axiosInstance.get(`/volunteer/volunteers`,{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    return volunteers.data;
  } catch (error) {
    console.error(error);
  }
};

export const addVolunteer = async (volunteer) => {
  try {
    var token = await Auth.getToken();
    const addVolunteer = await axiosInstance.post(`/volunteer/volunteers`, volunteer,{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    return addVolunteer.data;
  } catch (error) {
    console.error(error);
  }
};
export const deleteVolunteer = async (volunteerId) => {
  try {
    var token = await Auth.getToken();
    const deteleVolunteer = await axiosInstance.delete(`/volunteer/volunteers/${volunteerId}`,{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    return deteleVolunteer.data;
  } catch (error) {
    console.error(error);
  }
};

export const getEvents = async () => {
  try {
    var token = await Auth.getToken();
    const events = await axiosInstance.get(`/volunteer/events`,{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    var eventsData = events.data
    for (var i=0; i< eventsData.length; i++) {
      eventsData[i].start = moment(eventsData[i].start).toDate();
      eventsData[i].end = moment(eventsData[i].end).toDate();
    }
    return eventsData;
  } catch (error) {
    console.error(error);
  }
};
export const getEventsByPatientIDAdmin = async (id) => {
  try {
    var token = await Auth.getTokenVolunteer();
    const events = await axiosInstance.get(`/volunteer/events/patient/${id}`,{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    var eventsData = events.data
    for (var i=0; i< eventsData.length; i++) {
      eventsData[i].start = moment(eventsData[i].start).toDate();
      eventsData[i].end = moment(eventsData[i].end).toDate();
    }
    return eventsData;
  } catch (error) {
    console.error(error);
  }
};
export const getEventsByPatientID = async (id) => {
  try {
    var token = await Auth.getToken();
    const events = await axiosInstance.get(`/volunteer/events/patient/${id}`,{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    var eventsData = events.data
    for (var i=0; i< eventsData.length; i++) {
      eventsData[i].start = moment(eventsData[i].start).toDate();
      eventsData[i].end = moment(eventsData[i].end).toDate();
    }
    return eventsData;
  } catch (error) {
    console.error(error);
  }
};
export const getEventsByDate = async (date) => {
  try {
    var start = moment(date).format('YYYY-MM-DD');
    var end = moment(date).add(1,"days").format('YYYY-MM-DD');
    var token = await Auth.getTokenVolunteer();
    const events = await axiosInstance.get(`/volunteer/events/byDate/${start}/${end}`,{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    var eventsData = events.data
    for (var i=0; i< eventsData.length; i++) {
      eventsData[i].start = moment(eventsData[i].start).toDate();
      eventsData[i].end = moment(eventsData[i].end).toDate();
    }
    return eventsData;
  } catch (error) {
    console.error(error);
  }
};
export const getEventsByVolunteerID = async (id) => {
  try {
    var token = await Auth.getTokenVolunteer();
    const events = await axiosInstance.get(`/volunteer/events/volunteer/${id}`,{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    var eventsData = events.data
    for (var i=0; i< eventsData.length; i++) {
      eventsData[i].start = moment(eventsData[i].start).toDate();
      eventsData[i].end = moment(eventsData[i].end).toDate();
    }
    return eventsData;
  } catch (error) {
    console.error(error);
  }
};

export const getVoluntarById = async (id) => {
  try {
    var token = await Auth.getTokenVolunteer();
    const voluntar = await axiosInstance.get(`/volunteer/events/access/${id}`,{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    
    return voluntar.data;
  } catch (error) {
    console.error(error);
  }
};
export const getVoluntarDetailsById = async (id) => {
  try {
    var token = await Auth.getTokenVolunteer();
    const voluntar = await axiosInstance.get(`/volunteer/events/volunteerDetails/${id}`,{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    
    return voluntar.data;
  } catch (error) {
    console.error(error);
  }
};

export const deleteEvent = async (id) => {
  try {
    var token = await Auth.getTokenVolunteer();
    const voluntar = await axiosInstance.delete(`/volunteer/events/${id}`,{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
    return voluntar.data;
  } catch (error) {
    console.error(error);
  }
};

export const addEvent = async event => {
  try {
    var token = await Auth.getTokenVolunteer();
    await axiosInstance.post("/volunteer/events", event,{
      headers: {
          Authorization: `bearer ${token}`
      }
  });
  } catch (error) {
    console.error(error);
  }
};
